module.exports = __webpack_public_path__ + "static/media/bgLogin.f357bd90.jpg";